import React from 'react';
import { FileOrFormQuestion } from '../FileOrFormQuestion';
import { usePropertyBudgetFile } from '../../../../queries/PropertyFileFields/NonRentalFiles';
import { formConstant } from '../constants/FormConstant';

interface BudgetFileParameter {
    disableEditFormOptionBudget?: boolean;
    propertyGuid: string;
    required: boolean;
    isReview?: boolean;
}

export const BudgetFile: React.FC<BudgetFileParameter> = ({
    disableEditFormOptionBudget,
    required,
    propertyGuid,
    isReview = false,
}) => {
    const { handleMode, setHandleMode, filename: uploadFileName, setFilename: setUploadFileName, fileApiId: uploadedFileApiId, setFileApiId: setUploadedFileApiId } = usePropertyBudgetFile(propertyGuid);

    return (
        <div className='form-group'>
            <div className='row'>
                <FileOrFormQuestion
                    label={formConstant.displayName.budget}
                    selector='budget'
                    fileType={'budget'}
                    formTypeName={formConstant.displayName.budget}
                    disableEditFormOption={disableEditFormOptionBudget}
                    required={required}
                    isReview={isReview}
                    propertyGuid={propertyGuid}
                    handle={handleMode}
                    onHandleChange={setHandleMode}
                    uploadFileName={uploadFileName}
                    onUploadFileNameChange={setUploadFileName}
                    uploadedFileApiId={uploadedFileApiId}
                    onUploadedFileApiIdChange={setUploadedFileApiId}
                />
            </div>
        </div>
    );
};
